'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _authFormValidation = require('./authFormValidation');

var _authFormValidation2 = _interopRequireDefault(_authFormValidation);

var _formComponents = require('components/formComponents');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var RegistrationForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loginData: state.auth.loginData,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'RegistrationForm',
  propNamespace: 'registrationForm',
  validate: _authFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(RegistrationForm, _Component);

  function RegistrationForm() {
    var _ref;

    (0, _classCallCheck3.default)(this, RegistrationForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm)).call.apply(_ref, [this].concat(args)));

    _this.state = { showForgotForm: false };
    return _this;
  }

  (0, _createClass3.default)(RegistrationForm, [{
    key: 'submit',
    value: function submit(formData) {
      var _props = this.props,
          register = _props.register,
          loginData = _props.loginData;
      var password = formData.password;

      var email = loginData.email || formData.email;
      // catch requires for properly update form state
      return register(email, password).promise.catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'toggleForm',
    value: function toggleForm() {
      this.setState({ showForgotForm: !this.state.showForgotForm });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$registrationF = _props2.registrationForm,
          submitting = _props2$registrationF.submitting,
          handleSubmit = _props2$registrationF.handleSubmit,
          invalid = _props2$registrationF.invalid,
          t = _props2.t,
          className = _props2.className,
          loginData = _props2.loginData,
          showTerms = _props2.showTerms;
      var isMounted = this.state.isMounted;

      var styles = require('./AuthForm.scss');

      return this.state.showForgotForm ? _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(_components.ForgotPasswordForm, null),
        _react2.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-default margin-top-10', onClick: this.toggleForm },
          t('Login')
        )
      ) : _react2.default.createElement(
        'form',
        { className: 'form-horizontal ' + className, onSubmit: handleSubmit(this.submit) },
        _react2.default.createElement(
          'div',
          null,
          loginData.email ? _react2.default.createElement(_components.AuthEmailString, { email: loginData.email }) : _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Email') }),
          _react2.default.createElement(_reduxForm.Field, { name: 'password', type: 'password', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Password') }),
          _react2.default.createElement(_reduxForm.Field, { name: 'repassword', type: 'password', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Confirm password') }),
          _react2.default.createElement(
            'div',
            { className: styles.buttons },
            _react2.default.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary pull-right margin-vert-10 pos-rel', disabled: isMounted && (submitting || invalid) },
              t('Send'),
              submitting && _react2.default.createElement(_components.Loader, { mask: true })
            ),
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-default margin-vert-10', onClick: this.toggleForm },
              t('Forgot your password'),
              '?'
            )
          ),
          showTerms && _react2.default.createElement(_components.TermsAgreeLink, { className: 'text-center margin-top-30', buttonName: t('Send') })
        )
      );
    }
  }]);
  return RegistrationForm;
}(_ClientSideComponent2.default), _class3.propTypes = {
  className: _propTypes2.default.string,
  loginData: _propTypes2.default.object,
  register: _propTypes2.default.func,
  registrationForm: _propTypes2.default.object,
  showTerms: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleForm'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = RegistrationForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthForms/RegistrationForm.js
// module id = 1956
// module chunks = 1